/* unplugin-vue-components disabled */import script from "./NavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=94d8ddb8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d8ddb8"]])

export default __exports__